import Logo from '../../../images/Logo_Bn.png';
import './Footer.scss';

export default function Footer() {
	return (
		<div className='navbar-dark  bg-dark'>
			<div className='container'>
				<footer className='d-flex flex-wrap justify-content-between align-items-center py-4'>
					<div className='d-flex align-items-center'>
						<a href='/' className='me-2 text-muted text-decoration-none lh-1'>
							<img src={Logo} alt='Ekklexia' width='25' height='auto' />
						</a>
						<span className='text-muted'>
							Ekklexia Logistics © - All rights reserved 2021
						</span>
					</div>
					<ul className='nav justify-content-end list-unstyled d-flex'>
						<li className='ms-3'>
							<a className='text-muted' href='/#'>
								<i className='bi bi-twitter fs-4'></i>
							</a>
						</li>
						<li className='ms-3'>
							<a className='text-muted' href='/#'>
								<i className='bi bi-instagram fs-4'></i>
							</a>
						</li>
						<li className='ms-3'>
							<a className='text-muted' href='/#'>
								<i className='bi bi-facebook fs-4'></i>
							</a>
						</li>
					</ul>
				</footer>
			</div>
		</div>
	);
}
